import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import EmailInput from "../../Components/Inputs/EmailInput";
import PasswordInput from "../../Components/Inputs/PasswordInput";
import ContainedButton from "../../Components/Buttons/ContainedButton";
import { useLogin } from "../../Controllers/AuthController";
import { useForm } from "react-hook-form";
import { authLogger, uiLogger } from "../../Utils/logger";
import { useState } from "react";
import { useFcm } from "../../hooks/useFcm";
import useAuthStore from "../../zustand-stores/AuthStore";
import useUserStore from "../../zustand-stores/UserStore";
import { updateUserOnlineStatus, useFireStore } from "../../hooks/useFireStore";
import { useQueryClient } from "@tanstack/react-query";
import { remove } from "../../helpers/StorageHelper";
import { USER_CURRENT_LEVEL } from "../../constants/localStorageKeys";

const DEVICE_TYPE = "web";

export default function SignIn() {
  const navigate = useNavigate();
  const { mutate, error, isPending: loginPending } = useLogin();
  const { control, formState, handleSubmit } = useForm();
  const { isValid } = formState;

  const [isLoading, setIsLoading] = useState(false);

  const handleBackButton = () => {
    uiLogger.userAction("back_button_clicked", { from: "signin" });
    navigate("/");
  };

  const { getFcmToken } = useFcm();
  const { setAuthSession } = useAuthStore();
  const { setUser } = useUserStore();
  const queryClient = useQueryClient();

  const handleSuccessfulLogin = (data) => {
    authLogger.info("Login successful", {
      userId: data?.user?.id,
      email: data?.user?.email,
    });
    const token = data.token;
    const user = data.user;
    // Clear any cached data from previous sessions to avoid stale UI
    try {
      queryClient.clear();
    } catch (e) {
      console.warn("Failed to clear query cache on login", e);
    }
    // Reset any user-scoped persisted values
    remove(USER_CURRENT_LEVEL);
    setAuthSession(token);
    setUser(user);
    updateUserOnlineStatus(user, true);
    toast.success("Login successful!");
    navigate("/dashboard");
  };

  const handleLoginError = (error) => {
    authLogger.error("Login form submission error : ", error);
    toast.error(error?.response?.data?.message || "Login failed!");
  };

  const loginForm = async (data) => {
    setIsLoading(true);
    const { fcmToken, deviceId } = getFcmToken();

    const loginData = {
      email: data.email,
      password: data.password,
      device_token: fcmToken,
      device_id: deviceId,
      device_type: DEVICE_TYPE,
    };

    authLogger.userAction("login_form_submitted", { email: data.email });

    mutate(loginData, {
      onSuccess: (data) => handleSuccessfulLogin(data),
      onError: (error) => handleLoginError(error),
    });
  };

  return (
    /*
      <div className="onboarding-container">
        <div className="onboard-content flex-grow-1">
          <div className="admin-sign-in">
            <h4
              style={{
                marginBottom: "40px",
                textAlign: "center",
                color: "rgba(230, 236, 241, 1)",
                fontFamily: "Poppins",
                fontSize: "20px",
                lineHeight: "30px",
                fontWeight: 600,
              }}
            >
              Login Into Account
            </h4>
          </div>
        </div>
      </div>
      */

    <div>
      <form
        onSubmit={handleSubmit(loginForm)}
        className="d-flex flex-column align-items-center"
      >
        <div className="gap-3 gap-sm-4 d-flex flex-column align-items-center w-100">
          <div className="textfield-1 input-fields w-100">
            <EmailInput
              name="email"
              control={control}
              label="Enter email"
              placeholder=" "
              rules={{ required: "Email is required" }}
              className={`text-body-b2 w-100 ${error ? "error" : ""}`}
            />
          </div>
          <div className="textfield-1 input-fields password-container w-100">
            <PasswordInput
              name="password"
              control={control}
              label="Enter password"
              placeholder=" "
              rules={{ required: "Password is required" }}
              className={`text-body-b2 styled-input w-100 ${error ? "error" : ""}`}
              // Add onKeyDown handler here
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault(); // Prevents default form submission
                  handleSubmit(loginForm)(); // Manually trigger form submission
                }
              }}
            />
          </div>
        </div>
        <div className="forgot-password">
          <Link to="/forgot-password">Forgot Password?</Link>
        </div>
        <div
          className="d-flex flex-column flex-sm-row gap-3 gap-sm-4 terms-buttons align-items-center w-100"
          style={{ maxWidth: "345px", marginTop: "40px" }}
        >
          {/*<ContainedButton*/}
          {/*  type="button"*/}
          {/*  onClick={handleBackButton}*/}
          {/*  className={`btn-1 btn-1-basic`}*/}
          {/*  disabled={false}*/}
          {/*>*/}
          {/*  Back*/}
          {/*</ContainedButton>*/}
          <ContainedButton
            type="submit"
            isFormValid={isValid}
            isLoading={loginPending}
            style={{
              backgroundColor: loginPending
                ? "rgba(153, 209, 255, 1)"
                : isValid
                  ? "rgba(0, 140, 255, 1)"
                  : "rgba(153, 209, 255, 1)",
              color: "rgba(230, 236, 241, 1)",
              border: "1.5px solid rgba(0, 140, 255, 1)",
              borderRadius: "24px",
              padding: "6px 32px",
              width: "100%",
              height: "52px",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "24px",
              cursor: isValid || loginPending ? "pointer" : "not-allowed",
            }}
          >
            {loginPending ? "Logging in..." : "Login"}
          </ContainedButton>
        </div>
      </form>
    </div>

    //   </div>
    // </div>
  );
}
